import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {Helmet} from 'react-helmet-async'

import {useTryGetUrlParam} from '../../hooks/useTryGetUrlParam'

interface PlannerHelmetProps {
  title?: string
}

export const PlannerHelmet: React.FC<PlannerHelmetProps> = ({title}) => {
  const upmPlants = useUpmPlantsContext()

  const plantCode = useTryGetUrlParam('plantCode') ?? ''
  const plantName = getPlantName(upmPlants, plantCode)

  const titleParts = ['Planner', plantName, title].filter(Boolean)

  return (
    <Helmet>
      <title>{titleParts.join(' - ')}</title>
    </Helmet>
  )
}
